import { pricingPlans } from '@/mocks/homeContent';

export default function PricingSection() {
  return (
    <section id="pricing" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            PRICE GUIDE
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            分かりやすい<span className="text-primary-500">明朗料金</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            京都 不用品回収・京都 遺品整理の目安料金です。
            積載量やお品目により変動しますので、詳細は無料お見積りをご利用ください。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {pricingPlans.map((plan) => (
            <div
              key={plan.title}
              className={`relative rounded-lg overflow-hidden border transition-transform ${
                plan.highlight
                  ? 'border-primary-500 bg-background-50 md:-translate-y-3'
                  : 'border-background-200 bg-background-100'
              }`}
            >
              {plan.badge && (
                <div className="absolute top-0 inset-x-0 py-2 text-center bg-primary-500 text-background-50 text-xs font-bold tracking-wider">
                  {plan.badge}
                </div>
              )}
              <div className={`p-7 ${plan.badge ? 'pt-12' : ''}`}>
                <p className="text-xs font-semibold text-secondary-700 tracking-widest mb-2">
                  {plan.label}
                </p>
                <h3 className="text-2xl font-bold text-foreground-950 mb-4">
                  {plan.title}
                </h3>
                <div className="flex items-end gap-1 mb-2">
                  <span className="font-mincho text-5xl font-bold text-primary-600">
                    {plan.price}
                  </span>
                  <span className="text-foreground-700 text-base pb-2">円〜</span>
                  <span className="text-foreground-500 text-xs pb-2 ml-2">(税込)</span>
                </div>
                <div className="mt-4 pt-4 border-t border-background-200 space-y-2 text-sm text-foreground-700">
                  <div className="flex justify-between">
                    <span className="text-foreground-500">サイズ</span>
                    <span className="font-medium">{plan.size}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-foreground-500">積載目安</span>
                    <span className="font-medium">{plan.load}</span>
                  </div>
                </div>
                <ul className="mt-5 space-y-2">
                  {plan.features.map((f) => (
                    <li
                      key={f}
                      className="flex items-start gap-2 text-sm text-foreground-800"
                    >
                      <span className="w-4 h-4 mt-1 flex items-center justify-center text-accent-700">
                        <i className="ri-checkbox-circle-fill" />
                      </span>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className={`mt-6 w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md font-bold text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    plan.highlight
                      ? 'bg-primary-500 hover:bg-primary-600 text-background-50'
                      : 'bg-background-50 hover:bg-background-200 text-foreground-950 border border-background-300'
                  }`}
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-chat-quote-line" />
                  </span>
                  このプランで相談する
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 p-6 md:p-8 rounded-lg bg-secondary-100 border border-secondary-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 shrink-0">
              <span className="w-7 h-7 flex items-center justify-center text-2xl">
                <i className="ri-information-2-line" />
              </span>
            </div>
            <div className="text-sm text-secondary-900 leading-relaxed">
              <p className="font-bold mb-1">料金についてのご注意</p>
              <p>
                上記は京都府内における目安料金です。作業内容・階数・階段作業・時間帯・特殊品目(家電リサイクル対象品、産廃扱いの品など)により追加料金が発生する場合があります。
                お見積り後の追加請求は一切ありませんので、まずはお気軽にお問い合わせください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}